export enum Api6Errors {
  profileRejected = 'profile_rejected',
}
